import { useState } from "react";
import { Download, Check } from "lucide-react";

// ── Static share card assets — provided by Travelorza design team ─────────────
const BASE = "https://customer-assets.emergentagent.com/job_soulprint-travel/artifacts/";

const SHARE_CARDS = {
  Explorer:       [{ id: "explorer-identity",       label: "Identity Card",  url: `${BASE}d9y8qj16_The%20Explorer.png` },      { id: "explorer-manifesto",       label: "Manifesto Card", url: `${BASE}apv1lcg8_Explorer.png` }],
  Romantic:       [{ id: "romantic-identity",       label: "Identity Card",  url: `${BASE}dcg2saxt_The%20Romantic.png` },      { id: "romantic-manifesto",       label: "Manifesto Card", url: `${BASE}5nuadkp8_Romantic.png` }],
  Celebrator:     [{ id: "celebrator-identity",     label: "Identity Card",  url: `${BASE}bjbsy6yo_The%20Celebrator.png` },    { id: "celebrator-manifesto",     label: "Manifesto Card", url: `${BASE}d3761wup_Celebrator.png` }],
  Seeker:         [{ id: "seeker-identity",         label: "Identity Card",  url: `${BASE}hox2d1xi_The%20Seeker.png` },        { id: "seeker-manifesto",         label: "Manifesto Card", url: `${BASE}rseu24io_Seeker.png` }],
  Sensorialist:   [{ id: "sensorialist-identity",   label: "Identity Card",  url: `${BASE}inm8zsfx_The%20Sensorialist.png` },  { id: "sensorialist-manifesto",   label: "Manifesto Card", url: `${BASE}63d4uu3b_Sensorialist.png` }],
  "Soul Traveler":[{ id: "soultraveler-identity",   label: "Identity Card",  url: `${BASE}z3ke1dek_The%20Soul%20Traveler.png` },{ id: "soultraveler-manifesto",   label: "Manifesto Card", url: `${BASE}ytsrzdji_Soul%20Traveler.png` }],
};

async function downloadCard(card, archetype) {
  try {
    const response = await fetch(card.url, { mode: "cors" });
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `travelorza-soulprint-${archetype.toLowerCase().replace(/\s+/g, "-")}-${card.label.toLowerCase().replace(/\s+/g, "-")}.png`;
    a.click();
    URL.revokeObjectURL(url);
  } catch {
    window.open(card.url, "_blank");
  }
}

function CardItem({ card, archetype }) {
  const [downloading, setDownloading] = useState(false);
  const [done, setDone] = useState(false);

  const handleDownload = async () => {
    setDownloading(true);
    await downloadCard(card, archetype);
    setDownloading(false);
    setDone(true);
    setTimeout(() => setDone(false), 3000);
  };

  return (
    <div className="flex flex-col">
      {/* Card image */}
      <div className="rounded-xl overflow-hidden shadow-2xl border border-white/5 mb-3">
        <img src={card.url} alt={`${archetype} ${card.label}`} className="w-full h-auto block" loading="lazy" />
      </div>
      {/* Label */}
      <p className="text-[9px] uppercase tracking-[0.2em] text-[#71717A] text-center mb-2">{card.label}</p>
      {/* Per-card download */}
      <button
        data-testid={`download-${card.id}`}
        onClick={handleDownload}
        disabled={downloading}
        className="flex items-center justify-center gap-1.5 w-full py-2.5 border border-white/12 text-[#A1A1AA] rounded-sm text-xs hover:border-[#C9A84C]/30 hover:text-[#C9A84C] transition-all disabled:opacity-40"
      >
        {done ? <><Check size={11} /> Downloaded</> : downloading ? "Preparing..." : <><Download size={11} /> Download</>}
      </button>
    </div>
  );
}

export default function SoulprintShareSystem({ archetype }) {
  const cards = SHARE_CARDS[archetype] || SHARE_CARDS.Explorer;

  return (
    <div className="w-full">
      {/* Both cards always visible — desktop side by side, mobile stacked */}
      <div className="grid md:grid-cols-2 gap-6 mb-4">
        {cards.map(card => (
          <CardItem key={card.id} card={card} archetype={archetype} />
        ))}
      </div>
      {/* Helper text */}
      <p className="text-center text-[10px] text-[#71717A] leading-relaxed mt-2">
        Download and share to Instagram Stories, WhatsApp Status or any social platform.
      </p>
    </div>
  );
}
